import type { AxiosResponse } from 'axios';
import type {
  RegisterUserResponse,
  UserRegistrationConfirmRequest,
  UserRegistrationConfirmResponse,
  UserRegistrationIntentResponse,
  UserRegistrationRequest,
  UserRegistrationResendRequest,
} from './register.types';
import API from '@/services/API.ts';
import { userEndpoints } from '@/services/API.constants.ts';

export const fetchRegistrationIntent = async (_params: {
  externalSubscriptionId?: string;
  registrationToken?: string;
}): Promise<UserRegistrationIntentResponse> => {
  return (
    await API.get<UserRegistrationIntentResponse>(
      userEndpoints.registrationIntent,
      { params: _params },
    )
  ).data;
};

export const submitRegistration = async (
  _body: UserRegistrationRequest,
): Promise<AxiosResponse<RegisterUserResponse>> =>
  await API.post(userEndpoints.registration, _body);

export const confirmRegistration = async (
  _body: UserRegistrationConfirmRequest,
): Promise<AxiosResponse<UserRegistrationConfirmResponse>> =>
  await API.post(userEndpoints.registrationConfirm, _body);

export const resendRegistrationCode = async (
  _body: UserRegistrationResendRequest,
): Promise<void> => {
  await API.post(userEndpoints.registrationResend, _body);
};
